module.exports = __webpack_public_path__ + "img/homeHeathLogoOpacity.cce123b3.png";